
import Vue, { PropType } from 'vue'
import FileBrowserItem from './FileBrowserItem.vue'
import { RLoader, RCheckbox } from '@/components'
import { FileBrowserItems } from './types'
import { FileSystemItem } from '@/store/types/file'
import { RequestInfo } from '@/store/types/root'
import {
  DirectoryCreateModal,
  ItemUploadModal,
  ItemDeleteModal,
  ItemRenameModal,
  ItemLinkShareModal,
} from '@/components/modals/'

export default Vue.extend({
  name: 'FileBrowser',
  components: {
    RLoader,
    FileBrowserItem,
    ItemUploadModal,
    ItemRenameModal,
    ItemDeleteModal,
    DirectoryCreateModal,
    RCheckbox,
    ItemLinkShareModal,
  },
  props: {
    isShared: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array as PropType<FileBrowserItems>,
    },
    isLoadingFiles: {
      type: Boolean,
    },
    isLinkSharePending: {
      type: Boolean,
    },
    uploadInProgress: {
      type: Boolean,
    },
    link: {
      type: String,
    },
    canDownload: {
      type: Boolean,
    },
    directoryNames: {
      type: Array as PropType<string[]>,
    },
    itemNames: {
      type: Array as PropType<string[]>,
    },
    allSelected: {
      type: Boolean,
    },
    files: {
      type: Array,
    },
    directories: {
      type: Array,
    },
    loadFilesRequest: {
      type: RequestInfo,
    },
    shareLinkRequest: {
      type: RequestInfo,
    },
    selectionOptions: {
      type: Object,
    },
    path: {
      type: String,
    },
    driveUuid: { type: String },
    hash: { type: String },
    selectedPaths: {
      type: Set as PropType<Set<string>>,
    },
    selectedItems: {
      type: Array as PropType<FileSystemItem[]>,
    },
    singleSelectedItem: {
      type: Object as PropType<FileSystemItem>,
    },
    profile: {
      type: Object,
    },
  },

  watch: {
    // fires after breadcumb naviagation
    $route(_to, _from) {
      this.$emit('loadDirectory')
    },
  },
})
